// source: profileservice/blog.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var profileservice_blog_tag_pb = require('../profileservice/blog_tag_pb.js');
goog.object.extend(proto, profileservice_blog_tag_pb);
var profileservice_blog_category_pb = require('../profileservice/blog_category_pb.js');
goog.object.extend(proto, profileservice_blog_category_pb);
goog.exportSymbol('proto.profileservice.Blog', null, global);
goog.exportSymbol('proto.profileservice.BlogReply', null, global);
goog.exportSymbol('proto.profileservice.BlogSitemapReply', null, global);
goog.exportSymbol('proto.profileservice.BlogSitemapRequest', null, global);
goog.exportSymbol('proto.profileservice.BlogsReply', null, global);
goog.exportSymbol('proto.profileservice.CreateBlogRequest', null, global);
goog.exportSymbol('proto.profileservice.DeleteBlogReply', null, global);
goog.exportSymbol('proto.profileservice.DeleteBlogRequest', null, global);
goog.exportSymbol('proto.profileservice.GetBlogRequest', null, global);
goog.exportSymbol('proto.profileservice.GetBlogsRequest', null, global);
goog.exportSymbol('proto.profileservice.GetIsBloggerReply', null, global);
goog.exportSymbol('proto.profileservice.GetIsBloggerRequest', null, global);
goog.exportSymbol('proto.profileservice.SearchBlog', null, global);
goog.exportSymbol('proto.profileservice.SearchBlogsReply', null, global);
goog.exportSymbol('proto.profileservice.SearchBlogsRequest', null, global);
goog.exportSymbol('proto.profileservice.SitemapBlog', null, global);
goog.exportSymbol('proto.profileservice.Toc', null, global);
goog.exportSymbol('proto.profileservice.UpdateBlogRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.Blog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.Blog.repeatedFields_, null);
};
goog.inherits(proto.profileservice.Blog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.Blog.displayName = 'proto.profileservice.Blog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetBlogsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.GetBlogsRequest.repeatedFields_, null);
};
goog.inherits(proto.profileservice.GetBlogsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetBlogsRequest.displayName = 'proto.profileservice.GetBlogsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.BlogsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.BlogsReply.repeatedFields_, null);
};
goog.inherits(proto.profileservice.BlogsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.BlogsReply.displayName = 'proto.profileservice.BlogsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetBlogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.GetBlogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetBlogRequest.displayName = 'proto.profileservice.GetBlogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.BlogReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.BlogReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.BlogReply.displayName = 'proto.profileservice.BlogReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.CreateBlogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.CreateBlogRequest.repeatedFields_, null);
};
goog.inherits(proto.profileservice.CreateBlogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.CreateBlogRequest.displayName = 'proto.profileservice.CreateBlogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.UpdateBlogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.UpdateBlogRequest.repeatedFields_, null);
};
goog.inherits(proto.profileservice.UpdateBlogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.UpdateBlogRequest.displayName = 'proto.profileservice.UpdateBlogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.DeleteBlogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.DeleteBlogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.DeleteBlogRequest.displayName = 'proto.profileservice.DeleteBlogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.DeleteBlogReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.DeleteBlogReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.DeleteBlogReply.displayName = 'proto.profileservice.DeleteBlogReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.SearchBlogsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.SearchBlogsRequest.repeatedFields_, null);
};
goog.inherits(proto.profileservice.SearchBlogsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.SearchBlogsRequest.displayName = 'proto.profileservice.SearchBlogsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.SearchBlogsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.SearchBlogsReply.repeatedFields_, null);
};
goog.inherits(proto.profileservice.SearchBlogsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.SearchBlogsReply.displayName = 'proto.profileservice.SearchBlogsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.SearchBlog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.SearchBlog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.SearchBlog.displayName = 'proto.profileservice.SearchBlog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.BlogSitemapRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.BlogSitemapRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.BlogSitemapRequest.displayName = 'proto.profileservice.BlogSitemapRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.BlogSitemapReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.BlogSitemapReply.repeatedFields_, null);
};
goog.inherits(proto.profileservice.BlogSitemapReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.BlogSitemapReply.displayName = 'proto.profileservice.BlogSitemapReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.SitemapBlog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.SitemapBlog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.SitemapBlog.displayName = 'proto.profileservice.SitemapBlog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetIsBloggerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.GetIsBloggerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetIsBloggerRequest.displayName = 'proto.profileservice.GetIsBloggerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetIsBloggerReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.GetIsBloggerReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetIsBloggerReply.displayName = 'proto.profileservice.GetIsBloggerReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.Toc = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.Toc, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.Toc.displayName = 'proto.profileservice.Toc';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.Blog.repeatedFields_ = [13,29];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.Blog.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.Blog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.Blog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.Blog.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    blogCategory: (f = msg.getBlogCategory()) && profileservice_blog_category_pb.BlogCategory.toObject(includeInstance, f),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    body: jspb.Message.getFieldWithDefault(msg, 5, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 6, ""),
    coverImageUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    restriction: jspb.Message.getFieldWithDefault(msg, 9, 0),
    tocAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    createdAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
    blogTagsList: jspb.Message.toObjectList(msg.getBlogTagsList(),
    profileservice_blog_tag_pb.BlogTag.toObject, includeInstance),
    kind: jspb.Message.getFieldWithDefault(msg, 14, 0),
    openedAt: jspb.Message.getFieldWithDefault(msg, 15, 0),
    price: jspb.Message.getFieldWithDefault(msg, 16, 0),
    paidFg: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    paidBody: jspb.Message.getFieldWithDefault(msg, 18, ""),
    paidOrdersCount: jspb.Message.getFieldWithDefault(msg, 19, 0),
    paidBodyCharCount: jspb.Message.getFieldWithDefault(msg, 20, 0),
    paidImagesCount: jspb.Message.getFieldWithDefault(msg, 21, 0),
    paidVideosCount: jspb.Message.getFieldWithDefault(msg, 22, 0),
    blogDetailPath: jspb.Message.getFieldWithDefault(msg, 23, ""),
    deletedAt: jspb.Message.getFieldWithDefault(msg, 24, 0),
    favoriteCount: jspb.Message.getFieldWithDefault(msg, 25, 0),
    isFavorited: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
    isFirstOpen: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
    isPurchased: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
    tocList: jspb.Message.toObjectList(msg.getTocList(),
    proto.profileservice.Toc.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.Blog}
 */
proto.profileservice.Blog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.Blog;
  return proto.profileservice.Blog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.Blog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.Blog}
 */
proto.profileservice.Blog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = new profileservice_blog_category_pb.BlogCategory;
      reader.readMessage(value,profileservice_blog_category_pb.BlogCategory.deserializeBinaryFromReader);
      msg.setBlogCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverImageUrl(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRestriction(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTocAvailable(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 13:
      var value = new profileservice_blog_tag_pb.BlogTag;
      reader.readMessage(value,profileservice_blog_tag_pb.BlogTag.deserializeBinaryFromReader);
      msg.addBlogTags(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenedAt(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaidFg(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaidBody(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaidOrdersCount(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaidBodyCharCount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaidImagesCount(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaidVideosCount(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlogDetailPath(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeletedAt(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFavoriteCount(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFavorited(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFirstOpen(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPurchased(value);
      break;
    case 29:
      var value = new proto.profileservice.Toc;
      reader.readMessage(value,proto.profileservice.Toc.deserializeBinaryFromReader);
      msg.addToc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.Blog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.Blog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.Blog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.Blog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBlogCategory();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      profileservice_blog_category_pb.BlogCategory.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCoverImageUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getRestriction();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTocAvailable();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getBlogTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      profileservice_blog_tag_pb.BlogTag.serializeBinaryToWriter
    );
  }
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getOpenedAt();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getPaidFg();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getPaidBody();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getPaidOrdersCount();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getPaidBodyCharCount();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getPaidImagesCount();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getPaidVideosCount();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getBlogDetailPath();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getDeletedAt();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getFavoriteCount();
  if (f !== 0) {
    writer.writeInt32(
      25,
      f
    );
  }
  f = message.getIsFavorited();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getIsFirstOpen();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getIsPurchased();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getTocList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      29,
      f,
      proto.profileservice.Toc.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional BlogCategory blog_category = 3;
 * @return {?proto.profileservice.BlogCategory}
 */
proto.profileservice.Blog.prototype.getBlogCategory = function() {
  return /** @type{?proto.profileservice.BlogCategory} */ (
    jspb.Message.getWrapperField(this, profileservice_blog_category_pb.BlogCategory, 3));
};


/**
 * @param {?proto.profileservice.BlogCategory|undefined} value
 * @return {!proto.profileservice.Blog} returns this
*/
proto.profileservice.Blog.prototype.setBlogCategory = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.clearBlogCategory = function() {
  return this.setBlogCategory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.Blog.prototype.hasBlogCategory = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.profileservice.Blog.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string body = 5;
 * @return {string}
 */
proto.profileservice.Blog.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string summary = 6;
 * @return {string}
 */
proto.profileservice.Blog.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string cover_image_url = 7;
 * @return {string}
 */
proto.profileservice.Blog.prototype.getCoverImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setCoverImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 status = 8;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 restriction = 9;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getRestriction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setRestriction = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool toc_available = 10;
 * @return {boolean}
 */
proto.profileservice.Blog.prototype.getTocAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setTocAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int64 created_at = 11;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 updated_at = 12;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * repeated BlogTag blog_tags = 13;
 * @return {!Array<!proto.profileservice.BlogTag>}
 */
proto.profileservice.Blog.prototype.getBlogTagsList = function() {
  return /** @type{!Array<!proto.profileservice.BlogTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, profileservice_blog_tag_pb.BlogTag, 13));
};


/**
 * @param {!Array<!proto.profileservice.BlogTag>} value
 * @return {!proto.profileservice.Blog} returns this
*/
proto.profileservice.Blog.prototype.setBlogTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.profileservice.BlogTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.BlogTag}
 */
proto.profileservice.Blog.prototype.addBlogTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.profileservice.BlogTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.clearBlogTagsList = function() {
  return this.setBlogTagsList([]);
};


/**
 * optional int32 kind = 14;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 opened_at = 15;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getOpenedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setOpenedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 price = 16;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional bool paid_fg = 17;
 * @return {boolean}
 */
proto.profileservice.Blog.prototype.getPaidFg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setPaidFg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional string paid_body = 18;
 * @return {string}
 */
proto.profileservice.Blog.prototype.getPaidBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setPaidBody = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int32 paid_orders_count = 19;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getPaidOrdersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setPaidOrdersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 paid_body_char_count = 20;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getPaidBodyCharCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setPaidBodyCharCount = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int32 paid_images_count = 21;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getPaidImagesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setPaidImagesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int32 paid_videos_count = 22;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getPaidVideosCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setPaidVideosCount = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string blog_detail_path = 23;
 * @return {string}
 */
proto.profileservice.Blog.prototype.getBlogDetailPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setBlogDetailPath = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional int64 deleted_at = 24;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getDeletedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setDeletedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int32 favorite_count = 25;
 * @return {number}
 */
proto.profileservice.Blog.prototype.getFavoriteCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setFavoriteCount = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional bool is_favorited = 26;
 * @return {boolean}
 */
proto.profileservice.Blog.prototype.getIsFavorited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setIsFavorited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional bool is_first_open = 27;
 * @return {boolean}
 */
proto.profileservice.Blog.prototype.getIsFirstOpen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setIsFirstOpen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool is_purchased = 28;
 * @return {boolean}
 */
proto.profileservice.Blog.prototype.getIsPurchased = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.setIsPurchased = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * repeated Toc toc = 29;
 * @return {!Array<!proto.profileservice.Toc>}
 */
proto.profileservice.Blog.prototype.getTocList = function() {
  return /** @type{!Array<!proto.profileservice.Toc>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.Toc, 29));
};


/**
 * @param {!Array<!proto.profileservice.Toc>} value
 * @return {!proto.profileservice.Blog} returns this
*/
proto.profileservice.Blog.prototype.setTocList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 29, value);
};


/**
 * @param {!proto.profileservice.Toc=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.Toc}
 */
proto.profileservice.Blog.prototype.addToc = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 29, opt_value, proto.profileservice.Toc, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.Blog} returns this
 */
proto.profileservice.Blog.prototype.clearTocList = function() {
  return this.setTocList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.GetBlogsRequest.repeatedFields_ = [1,2,3,4,9,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetBlogsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetBlogsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetBlogsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    blogCategoryIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    blogTagIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    exceptBlogIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    yearAndMonth: jspb.Message.getFieldWithDefault(msg, 5, 0),
    page: jspb.Message.getFieldWithDefault(msg, 6, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 7, 0),
    isMine: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    kindsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    isFollowing: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    followeeUserIdsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    userId: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetBlogsRequest}
 */
proto.profileservice.GetBlogsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetBlogsRequest;
  return proto.profileservice.GetBlogsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetBlogsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetBlogsRequest}
 */
proto.profileservice.GetBlogsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setUserIdsList(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlogCategoryIdsList(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlogTagIdsList(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setExceptBlogIdsList(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYearAndMonth(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMine(value);
      break;
    case 9:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setKindsList(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFollowing(value);
      break;
    case 11:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setFolloweeUserIdsList(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetBlogsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetBlogsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetBlogsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getBlogCategoryIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getBlogTagIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
  f = message.getExceptBlogIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
  f = message.getYearAndMonth();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getIsMine();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getKindsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      9,
      f
    );
  }
  f = message.getIsFollowing();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getFolloweeUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      11,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
};


/**
 * repeated int32 user_ids = 1;
 * @return {!Array<number>}
 */
proto.profileservice.GetBlogsRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * repeated int32 blog_category_ids = 2;
 * @return {!Array<number>}
 */
proto.profileservice.GetBlogsRequest.prototype.getBlogCategoryIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setBlogCategoryIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.addBlogCategoryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.clearBlogCategoryIdsList = function() {
  return this.setBlogCategoryIdsList([]);
};


/**
 * repeated int32 blog_tag_ids = 3;
 * @return {!Array<number>}
 */
proto.profileservice.GetBlogsRequest.prototype.getBlogTagIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setBlogTagIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.addBlogTagIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.clearBlogTagIdsList = function() {
  return this.setBlogTagIdsList([]);
};


/**
 * repeated int32 except_blog_ids = 4;
 * @return {!Array<number>}
 */
proto.profileservice.GetBlogsRequest.prototype.getExceptBlogIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setExceptBlogIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.addExceptBlogIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.clearExceptBlogIdsList = function() {
  return this.setExceptBlogIdsList([]);
};


/**
 * optional int32 year_and_month = 5;
 * @return {number}
 */
proto.profileservice.GetBlogsRequest.prototype.getYearAndMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setYearAndMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 page = 6;
 * @return {number}
 */
proto.profileservice.GetBlogsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 limit = 7;
 * @return {number}
 */
proto.profileservice.GetBlogsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool is_mine = 8;
 * @return {boolean}
 */
proto.profileservice.GetBlogsRequest.prototype.getIsMine = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setIsMine = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * repeated int32 kinds = 9;
 * @return {!Array<number>}
 */
proto.profileservice.GetBlogsRequest.prototype.getKindsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setKindsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.addKinds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.clearKindsList = function() {
  return this.setKindsList([]);
};


/**
 * optional bool is_following = 10;
 * @return {boolean}
 */
proto.profileservice.GetBlogsRequest.prototype.getIsFollowing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setIsFollowing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * repeated int32 followee_user_ids = 11;
 * @return {!Array<number>}
 */
proto.profileservice.GetBlogsRequest.prototype.getFolloweeUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setFolloweeUserIdsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.addFolloweeUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.clearFolloweeUserIdsList = function() {
  return this.setFolloweeUserIdsList([]);
};


/**
 * optional int32 user_id = 12;
 * @return {number}
 */
proto.profileservice.GetBlogsRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogsRequest} returns this
 */
proto.profileservice.GetBlogsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.BlogsReply.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.BlogsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.BlogsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.BlogsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    blogsList: jspb.Message.toObjectList(msg.getBlogsList(),
    proto.profileservice.Blog.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0),
    blogUserIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.BlogsReply}
 */
proto.profileservice.BlogsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.BlogsReply;
  return proto.profileservice.BlogsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.BlogsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.BlogsReply}
 */
proto.profileservice.BlogsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.profileservice.Blog;
      reader.readMessage(value,proto.profileservice.Blog.deserializeBinaryFromReader);
      msg.addBlogs(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlogUserIdsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.BlogsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.BlogsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.BlogsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.profileservice.Blog.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBlogUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
};


/**
 * repeated Blog blogs = 1;
 * @return {!Array<!proto.profileservice.Blog>}
 */
proto.profileservice.BlogsReply.prototype.getBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.Blog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.Blog, 1));
};


/**
 * @param {!Array<!proto.profileservice.Blog>} value
 * @return {!proto.profileservice.BlogsReply} returns this
*/
proto.profileservice.BlogsReply.prototype.setBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.profileservice.Blog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.Blog}
 */
proto.profileservice.BlogsReply.prototype.addBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.profileservice.Blog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.BlogsReply} returns this
 */
proto.profileservice.BlogsReply.prototype.clearBlogsList = function() {
  return this.setBlogsList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.profileservice.BlogsReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogsReply} returns this
 */
proto.profileservice.BlogsReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int32 blog_user_ids = 3;
 * @return {!Array<number>}
 */
proto.profileservice.BlogsReply.prototype.getBlogUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.BlogsReply} returns this
 */
proto.profileservice.BlogsReply.prototype.setBlogUserIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.BlogsReply} returns this
 */
proto.profileservice.BlogsReply.prototype.addBlogUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.BlogsReply} returns this
 */
proto.profileservice.BlogsReply.prototype.clearBlogUserIdsList = function() {
  return this.setBlogUserIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetBlogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetBlogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetBlogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    isMine: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    userId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetBlogRequest}
 */
proto.profileservice.GetBlogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetBlogRequest;
  return proto.profileservice.GetBlogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetBlogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetBlogRequest}
 */
proto.profileservice.GetBlogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMine(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetBlogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetBlogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetBlogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIsMine();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profileservice.GetBlogRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogRequest} returns this
 */
proto.profileservice.GetBlogRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool is_mine = 2;
 * @return {boolean}
 */
proto.profileservice.GetBlogRequest.prototype.getIsMine = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.GetBlogRequest} returns this
 */
proto.profileservice.GetBlogRequest.prototype.setIsMine = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int32 user_id = 3;
 * @return {number}
 */
proto.profileservice.GetBlogRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogRequest} returns this
 */
proto.profileservice.GetBlogRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.BlogReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.BlogReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.BlogReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    blog: (f = msg.getBlog()) && proto.profileservice.Blog.toObject(includeInstance, f),
    previousBlog: (f = msg.getPreviousBlog()) && proto.profileservice.Blog.toObject(includeInstance, f),
    nextBlog: (f = msg.getNextBlog()) && proto.profileservice.Blog.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.BlogReply}
 */
proto.profileservice.BlogReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.BlogReply;
  return proto.profileservice.BlogReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.BlogReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.BlogReply}
 */
proto.profileservice.BlogReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.profileservice.Blog;
      reader.readMessage(value,proto.profileservice.Blog.deserializeBinaryFromReader);
      msg.setBlog(value);
      break;
    case 2:
      var value = new proto.profileservice.Blog;
      reader.readMessage(value,proto.profileservice.Blog.deserializeBinaryFromReader);
      msg.setPreviousBlog(value);
      break;
    case 3:
      var value = new proto.profileservice.Blog;
      reader.readMessage(value,proto.profileservice.Blog.deserializeBinaryFromReader);
      msg.setNextBlog(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.BlogReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.BlogReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.BlogReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlog();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.profileservice.Blog.serializeBinaryToWriter
    );
  }
  f = message.getPreviousBlog();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.profileservice.Blog.serializeBinaryToWriter
    );
  }
  f = message.getNextBlog();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.profileservice.Blog.serializeBinaryToWriter
    );
  }
};


/**
 * optional Blog blog = 1;
 * @return {?proto.profileservice.Blog}
 */
proto.profileservice.BlogReply.prototype.getBlog = function() {
  return /** @type{?proto.profileservice.Blog} */ (
    jspb.Message.getWrapperField(this, proto.profileservice.Blog, 1));
};


/**
 * @param {?proto.profileservice.Blog|undefined} value
 * @return {!proto.profileservice.BlogReply} returns this
*/
proto.profileservice.BlogReply.prototype.setBlog = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.BlogReply} returns this
 */
proto.profileservice.BlogReply.prototype.clearBlog = function() {
  return this.setBlog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.BlogReply.prototype.hasBlog = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Blog previous_blog = 2;
 * @return {?proto.profileservice.Blog}
 */
proto.profileservice.BlogReply.prototype.getPreviousBlog = function() {
  return /** @type{?proto.profileservice.Blog} */ (
    jspb.Message.getWrapperField(this, proto.profileservice.Blog, 2));
};


/**
 * @param {?proto.profileservice.Blog|undefined} value
 * @return {!proto.profileservice.BlogReply} returns this
*/
proto.profileservice.BlogReply.prototype.setPreviousBlog = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.BlogReply} returns this
 */
proto.profileservice.BlogReply.prototype.clearPreviousBlog = function() {
  return this.setPreviousBlog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.BlogReply.prototype.hasPreviousBlog = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Blog next_blog = 3;
 * @return {?proto.profileservice.Blog}
 */
proto.profileservice.BlogReply.prototype.getNextBlog = function() {
  return /** @type{?proto.profileservice.Blog} */ (
    jspb.Message.getWrapperField(this, proto.profileservice.Blog, 3));
};


/**
 * @param {?proto.profileservice.Blog|undefined} value
 * @return {!proto.profileservice.BlogReply} returns this
*/
proto.profileservice.BlogReply.prototype.setNextBlog = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.BlogReply} returns this
 */
proto.profileservice.BlogReply.prototype.clearNextBlog = function() {
  return this.setNextBlog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.BlogReply.prototype.hasNextBlog = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.CreateBlogRequest.repeatedFields_ = [10,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.CreateBlogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.CreateBlogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.CreateBlogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.CreateBlogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    blogCategoryId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 4, ""),
    body: jspb.Message.getFieldWithDefault(msg, 5, ""),
    coverImageUrl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0),
    restriction: jspb.Message.getFieldWithDefault(msg, 8, 0),
    tocAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    blogTagNamesList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    kind: jspb.Message.getFieldWithDefault(msg, 11, 0),
    paidFg: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    price: jspb.Message.getFieldWithDefault(msg, 13, 0),
    paidBody: jspb.Message.getFieldWithDefault(msg, 14, ""),
    tocList: jspb.Message.toObjectList(msg.getTocList(),
    proto.profileservice.Toc.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.CreateBlogRequest}
 */
proto.profileservice.CreateBlogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.CreateBlogRequest;
  return proto.profileservice.CreateBlogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.CreateBlogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.CreateBlogRequest}
 */
proto.profileservice.CreateBlogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogCategoryId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverImageUrl(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRestriction(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTocAvailable(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addBlogTagNames(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaidFg(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaidBody(value);
      break;
    case 15:
      var value = new proto.profileservice.Toc;
      reader.readMessage(value,proto.profileservice.Toc.deserializeBinaryFromReader);
      msg.addToc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.CreateBlogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.CreateBlogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.CreateBlogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.CreateBlogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBlogCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCoverImageUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getRestriction();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTocAvailable();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getBlogTagNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPaidFg();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getPaidBody();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTocList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.profileservice.Toc.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.profileservice.CreateBlogRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 blog_category_id = 2;
 * @return {number}
 */
proto.profileservice.CreateBlogRequest.prototype.getBlogCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setBlogCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.profileservice.CreateBlogRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string summary = 4;
 * @return {string}
 */
proto.profileservice.CreateBlogRequest.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string body = 5;
 * @return {string}
 */
proto.profileservice.CreateBlogRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string cover_image_url = 6;
 * @return {string}
 */
proto.profileservice.CreateBlogRequest.prototype.getCoverImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setCoverImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 status = 7;
 * @return {number}
 */
proto.profileservice.CreateBlogRequest.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 restriction = 8;
 * @return {number}
 */
proto.profileservice.CreateBlogRequest.prototype.getRestriction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setRestriction = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool toc_available = 9;
 * @return {boolean}
 */
proto.profileservice.CreateBlogRequest.prototype.getTocAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setTocAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * repeated string blog_tag_names = 10;
 * @return {!Array<string>}
 */
proto.profileservice.CreateBlogRequest.prototype.getBlogTagNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setBlogTagNamesList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.addBlogTagNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.clearBlogTagNamesList = function() {
  return this.setBlogTagNamesList([]);
};


/**
 * optional int32 kind = 11;
 * @return {number}
 */
proto.profileservice.CreateBlogRequest.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool paid_fg = 12;
 * @return {boolean}
 */
proto.profileservice.CreateBlogRequest.prototype.getPaidFg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setPaidFg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional int32 price = 13;
 * @return {number}
 */
proto.profileservice.CreateBlogRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string paid_body = 14;
 * @return {string}
 */
proto.profileservice.CreateBlogRequest.prototype.getPaidBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.setPaidBody = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * repeated Toc toc = 15;
 * @return {!Array<!proto.profileservice.Toc>}
 */
proto.profileservice.CreateBlogRequest.prototype.getTocList = function() {
  return /** @type{!Array<!proto.profileservice.Toc>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.Toc, 15));
};


/**
 * @param {!Array<!proto.profileservice.Toc>} value
 * @return {!proto.profileservice.CreateBlogRequest} returns this
*/
proto.profileservice.CreateBlogRequest.prototype.setTocList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.profileservice.Toc=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.Toc}
 */
proto.profileservice.CreateBlogRequest.prototype.addToc = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.profileservice.Toc, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.CreateBlogRequest} returns this
 */
proto.profileservice.CreateBlogRequest.prototype.clearTocList = function() {
  return this.setTocList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.UpdateBlogRequest.repeatedFields_ = [11,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.UpdateBlogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.UpdateBlogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.UpdateBlogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.UpdateBlogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    blogCategoryId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 5, ""),
    body: jspb.Message.getFieldWithDefault(msg, 6, ""),
    coverImageUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    restriction: jspb.Message.getFieldWithDefault(msg, 9, 0),
    tocAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    blogTagNamesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    kind: jspb.Message.getFieldWithDefault(msg, 12, 0),
    paidFg: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    price: jspb.Message.getFieldWithDefault(msg, 14, 0),
    paidBody: jspb.Message.getFieldWithDefault(msg, 15, ""),
    tocList: jspb.Message.toObjectList(msg.getTocList(),
    proto.profileservice.Toc.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.UpdateBlogRequest}
 */
proto.profileservice.UpdateBlogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.UpdateBlogRequest;
  return proto.profileservice.UpdateBlogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.UpdateBlogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.UpdateBlogRequest}
 */
proto.profileservice.UpdateBlogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogCategoryId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverImageUrl(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRestriction(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTocAvailable(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addBlogTagNames(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaidFg(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaidBody(value);
      break;
    case 16:
      var value = new proto.profileservice.Toc;
      reader.readMessage(value,proto.profileservice.Toc.deserializeBinaryFromReader);
      msg.addToc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.UpdateBlogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.UpdateBlogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.UpdateBlogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.UpdateBlogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBlogCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCoverImageUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getRestriction();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTocAvailable();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getBlogTagNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getPaidFg();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getPaidBody();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTocList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.profileservice.Toc.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profileservice.UpdateBlogRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.profileservice.UpdateBlogRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 blog_category_id = 3;
 * @return {number}
 */
proto.profileservice.UpdateBlogRequest.prototype.getBlogCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setBlogCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.profileservice.UpdateBlogRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string summary = 5;
 * @return {string}
 */
proto.profileservice.UpdateBlogRequest.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string body = 6;
 * @return {string}
 */
proto.profileservice.UpdateBlogRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string cover_image_url = 7;
 * @return {string}
 */
proto.profileservice.UpdateBlogRequest.prototype.getCoverImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setCoverImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 status = 8;
 * @return {number}
 */
proto.profileservice.UpdateBlogRequest.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 restriction = 9;
 * @return {number}
 */
proto.profileservice.UpdateBlogRequest.prototype.getRestriction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setRestriction = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool toc_available = 10;
 * @return {boolean}
 */
proto.profileservice.UpdateBlogRequest.prototype.getTocAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setTocAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * repeated string blog_tag_names = 11;
 * @return {!Array<string>}
 */
proto.profileservice.UpdateBlogRequest.prototype.getBlogTagNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setBlogTagNamesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.addBlogTagNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.clearBlogTagNamesList = function() {
  return this.setBlogTagNamesList([]);
};


/**
 * optional int32 kind = 12;
 * @return {number}
 */
proto.profileservice.UpdateBlogRequest.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool paid_fg = 13;
 * @return {boolean}
 */
proto.profileservice.UpdateBlogRequest.prototype.getPaidFg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setPaidFg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional int32 price = 14;
 * @return {number}
 */
proto.profileservice.UpdateBlogRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string paid_body = 15;
 * @return {string}
 */
proto.profileservice.UpdateBlogRequest.prototype.getPaidBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.setPaidBody = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated Toc toc = 16;
 * @return {!Array<!proto.profileservice.Toc>}
 */
proto.profileservice.UpdateBlogRequest.prototype.getTocList = function() {
  return /** @type{!Array<!proto.profileservice.Toc>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.Toc, 16));
};


/**
 * @param {!Array<!proto.profileservice.Toc>} value
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
*/
proto.profileservice.UpdateBlogRequest.prototype.setTocList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.profileservice.Toc=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.Toc}
 */
proto.profileservice.UpdateBlogRequest.prototype.addToc = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.profileservice.Toc, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.UpdateBlogRequest} returns this
 */
proto.profileservice.UpdateBlogRequest.prototype.clearTocList = function() {
  return this.setTocList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.DeleteBlogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.DeleteBlogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.DeleteBlogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.DeleteBlogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.DeleteBlogRequest}
 */
proto.profileservice.DeleteBlogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.DeleteBlogRequest;
  return proto.profileservice.DeleteBlogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.DeleteBlogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.DeleteBlogRequest}
 */
proto.profileservice.DeleteBlogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.DeleteBlogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.DeleteBlogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.DeleteBlogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.DeleteBlogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profileservice.DeleteBlogRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.DeleteBlogRequest} returns this
 */
proto.profileservice.DeleteBlogRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.profileservice.DeleteBlogRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.DeleteBlogRequest} returns this
 */
proto.profileservice.DeleteBlogRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.DeleteBlogReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.DeleteBlogReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.DeleteBlogReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.DeleteBlogReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.DeleteBlogReply}
 */
proto.profileservice.DeleteBlogReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.DeleteBlogReply;
  return proto.profileservice.DeleteBlogReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.DeleteBlogReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.DeleteBlogReply}
 */
proto.profileservice.DeleteBlogReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.DeleteBlogReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.DeleteBlogReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.DeleteBlogReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.DeleteBlogReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.SearchBlogsRequest.repeatedFields_ = [2,3,4,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.SearchBlogsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.SearchBlogsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.SearchBlogsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.SearchBlogsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tab: jspb.Message.getFieldWithDefault(msg, 1, 0),
    kindsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    blogCategoryIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    blogTagIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    keyword: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isOnlyFollowing: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    sortBy: jspb.Message.getFieldWithDefault(msg, 7, ""),
    page: jspb.Message.getFieldWithDefault(msg, 8, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 9, 0),
    urlForLog: jspb.Message.getFieldWithDefault(msg, 10, ""),
    followeeUserIdsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    userId: jspb.Message.getFieldWithDefault(msg, 12, 0),
    isPaidPriority: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    userAgent: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.SearchBlogsRequest}
 */
proto.profileservice.SearchBlogsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.SearchBlogsRequest;
  return proto.profileservice.SearchBlogsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.SearchBlogsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.SearchBlogsRequest}
 */
proto.profileservice.SearchBlogsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTab(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setKindsList(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlogCategoryIdsList(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlogTagIdsList(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOnlyFollowing(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortBy(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrlForLog(value);
      break;
    case 11:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setFolloweeUserIdsList(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPaidPriority(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserAgent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.SearchBlogsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.SearchBlogsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.SearchBlogsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.SearchBlogsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTab();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getKindsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getBlogCategoryIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
  f = message.getBlogTagIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsOnlyFollowing();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getSortBy();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getUrlForLog();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFolloweeUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      11,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getIsPaidPriority();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getUserAgent();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional int32 tab = 1;
 * @return {number}
 */
proto.profileservice.SearchBlogsRequest.prototype.getTab = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setTab = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 kinds = 2;
 * @return {!Array<number>}
 */
proto.profileservice.SearchBlogsRequest.prototype.getKindsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setKindsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.addKinds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.clearKindsList = function() {
  return this.setKindsList([]);
};


/**
 * repeated int32 blog_category_ids = 3;
 * @return {!Array<number>}
 */
proto.profileservice.SearchBlogsRequest.prototype.getBlogCategoryIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setBlogCategoryIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.addBlogCategoryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.clearBlogCategoryIdsList = function() {
  return this.setBlogCategoryIdsList([]);
};


/**
 * repeated int32 blog_tag_ids = 4;
 * @return {!Array<number>}
 */
proto.profileservice.SearchBlogsRequest.prototype.getBlogTagIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setBlogTagIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.addBlogTagIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.clearBlogTagIdsList = function() {
  return this.setBlogTagIdsList([]);
};


/**
 * optional string keyword = 5;
 * @return {string}
 */
proto.profileservice.SearchBlogsRequest.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_only_following = 6;
 * @return {boolean}
 */
proto.profileservice.SearchBlogsRequest.prototype.getIsOnlyFollowing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setIsOnlyFollowing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string sort_by = 7;
 * @return {string}
 */
proto.profileservice.SearchBlogsRequest.prototype.getSortBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 page = 8;
 * @return {number}
 */
proto.profileservice.SearchBlogsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 per_page = 9;
 * @return {number}
 */
proto.profileservice.SearchBlogsRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string url_for_log = 10;
 * @return {string}
 */
proto.profileservice.SearchBlogsRequest.prototype.getUrlForLog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setUrlForLog = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated int32 followee_user_ids = 11;
 * @return {!Array<number>}
 */
proto.profileservice.SearchBlogsRequest.prototype.getFolloweeUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setFolloweeUserIdsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.addFolloweeUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.clearFolloweeUserIdsList = function() {
  return this.setFolloweeUserIdsList([]);
};


/**
 * optional int32 user_id = 12;
 * @return {number}
 */
proto.profileservice.SearchBlogsRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool is_paid_priority = 13;
 * @return {boolean}
 */
proto.profileservice.SearchBlogsRequest.prototype.getIsPaidPriority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setIsPaidPriority = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string user_agent = 14;
 * @return {string}
 */
proto.profileservice.SearchBlogsRequest.prototype.getUserAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlogsRequest} returns this
 */
proto.profileservice.SearchBlogsRequest.prototype.setUserAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.SearchBlogsReply.repeatedFields_ = [4,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.SearchBlogsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.SearchBlogsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.SearchBlogsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.SearchBlogsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
    beginItemNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    endItemNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    blogTagsList: jspb.Message.toObjectList(msg.getBlogTagsList(),
    profileservice_blog_tag_pb.BlogTag.toObject, includeInstance),
    searchBlogsRequest: (f = msg.getSearchBlogsRequest()) && proto.profileservice.SearchBlogsRequest.toObject(includeInstance, f),
    searchBlogsList: jspb.Message.toObjectList(msg.getSearchBlogsList(),
    proto.profileservice.SearchBlog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.SearchBlogsReply}
 */
proto.profileservice.SearchBlogsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.SearchBlogsReply;
  return proto.profileservice.SearchBlogsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.SearchBlogsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.SearchBlogsReply}
 */
proto.profileservice.SearchBlogsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalNumber(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBeginItemNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEndItemNumber(value);
      break;
    case 4:
      var value = new profileservice_blog_tag_pb.BlogTag;
      reader.readMessage(value,profileservice_blog_tag_pb.BlogTag.deserializeBinaryFromReader);
      msg.addBlogTags(value);
      break;
    case 5:
      var value = new proto.profileservice.SearchBlogsRequest;
      reader.readMessage(value,proto.profileservice.SearchBlogsRequest.deserializeBinaryFromReader);
      msg.setSearchBlogsRequest(value);
      break;
    case 6:
      var value = new proto.profileservice.SearchBlog;
      reader.readMessage(value,proto.profileservice.SearchBlog.deserializeBinaryFromReader);
      msg.addSearchBlogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.SearchBlogsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.SearchBlogsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.SearchBlogsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.SearchBlogsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBeginItemNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getEndItemNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBlogTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      profileservice_blog_tag_pb.BlogTag.serializeBinaryToWriter
    );
  }
  f = message.getSearchBlogsRequest();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.profileservice.SearchBlogsRequest.serializeBinaryToWriter
    );
  }
  f = message.getSearchBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.profileservice.SearchBlog.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 total_number = 1;
 * @return {number}
 */
proto.profileservice.SearchBlogsReply.prototype.getTotalNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlogsReply} returns this
 */
proto.profileservice.SearchBlogsReply.prototype.setTotalNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 begin_item_number = 2;
 * @return {number}
 */
proto.profileservice.SearchBlogsReply.prototype.getBeginItemNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlogsReply} returns this
 */
proto.profileservice.SearchBlogsReply.prototype.setBeginItemNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 end_item_number = 3;
 * @return {number}
 */
proto.profileservice.SearchBlogsReply.prototype.getEndItemNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlogsReply} returns this
 */
proto.profileservice.SearchBlogsReply.prototype.setEndItemNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated BlogTag blog_tags = 4;
 * @return {!Array<!proto.profileservice.BlogTag>}
 */
proto.profileservice.SearchBlogsReply.prototype.getBlogTagsList = function() {
  return /** @type{!Array<!proto.profileservice.BlogTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, profileservice_blog_tag_pb.BlogTag, 4));
};


/**
 * @param {!Array<!proto.profileservice.BlogTag>} value
 * @return {!proto.profileservice.SearchBlogsReply} returns this
*/
proto.profileservice.SearchBlogsReply.prototype.setBlogTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.profileservice.BlogTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.BlogTag}
 */
proto.profileservice.SearchBlogsReply.prototype.addBlogTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.profileservice.BlogTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.SearchBlogsReply} returns this
 */
proto.profileservice.SearchBlogsReply.prototype.clearBlogTagsList = function() {
  return this.setBlogTagsList([]);
};


/**
 * optional SearchBlogsRequest search_blogs_request = 5;
 * @return {?proto.profileservice.SearchBlogsRequest}
 */
proto.profileservice.SearchBlogsReply.prototype.getSearchBlogsRequest = function() {
  return /** @type{?proto.profileservice.SearchBlogsRequest} */ (
    jspb.Message.getWrapperField(this, proto.profileservice.SearchBlogsRequest, 5));
};


/**
 * @param {?proto.profileservice.SearchBlogsRequest|undefined} value
 * @return {!proto.profileservice.SearchBlogsReply} returns this
*/
proto.profileservice.SearchBlogsReply.prototype.setSearchBlogsRequest = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.SearchBlogsReply} returns this
 */
proto.profileservice.SearchBlogsReply.prototype.clearSearchBlogsRequest = function() {
  return this.setSearchBlogsRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.SearchBlogsReply.prototype.hasSearchBlogsRequest = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated SearchBlog search_blogs = 6;
 * @return {!Array<!proto.profileservice.SearchBlog>}
 */
proto.profileservice.SearchBlogsReply.prototype.getSearchBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.SearchBlog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.SearchBlog, 6));
};


/**
 * @param {!Array<!proto.profileservice.SearchBlog>} value
 * @return {!proto.profileservice.SearchBlogsReply} returns this
*/
proto.profileservice.SearchBlogsReply.prototype.setSearchBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.profileservice.SearchBlog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.SearchBlog}
 */
proto.profileservice.SearchBlogsReply.prototype.addSearchBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.profileservice.SearchBlog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.SearchBlogsReply} returns this
 */
proto.profileservice.SearchBlogsReply.prototype.clearSearchBlogsList = function() {
  return this.setSearchBlogsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.SearchBlog.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.SearchBlog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.SearchBlog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.SearchBlog.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    kind: jspb.Message.getFieldWithDefault(msg, 2, 0),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    summary: jspb.Message.getFieldWithDefault(msg, 4, ""),
    openedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    coverImageUrl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    blogCategoryId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    blogCategoryName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    userName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    userIconPath: jspb.Message.getFieldWithDefault(msg, 11, ""),
    price: jspb.Message.getFieldWithDefault(msg, 12, 0),
    favoriteCount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    isFavorited: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    isPurchased: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.SearchBlog}
 */
proto.profileservice.SearchBlog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.SearchBlog;
  return proto.profileservice.SearchBlog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.SearchBlog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.SearchBlog}
 */
proto.profileservice.SearchBlog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverImageUrl(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogCategoryId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlogCategoryName(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserIconPath(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFavoriteCount(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFavorited(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPurchased(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.SearchBlog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.SearchBlog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.SearchBlog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.SearchBlog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOpenedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCoverImageUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBlogCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getBlogCategoryName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUserIconPath();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getFavoriteCount();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getIsFavorited();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getIsPurchased();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profileservice.SearchBlog.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 kind = 2;
 * @return {number}
 */
proto.profileservice.SearchBlog.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.profileservice.SearchBlog.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string summary = 4;
 * @return {string}
 */
proto.profileservice.SearchBlog.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 opened_at = 5;
 * @return {number}
 */
proto.profileservice.SearchBlog.prototype.getOpenedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setOpenedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string cover_image_url = 6;
 * @return {string}
 */
proto.profileservice.SearchBlog.prototype.getCoverImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setCoverImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 blog_category_id = 7;
 * @return {number}
 */
proto.profileservice.SearchBlog.prototype.getBlogCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setBlogCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string blog_category_name = 8;
 * @return {string}
 */
proto.profileservice.SearchBlog.prototype.getBlogCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setBlogCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 user_id = 9;
 * @return {number}
 */
proto.profileservice.SearchBlog.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string user_name = 10;
 * @return {string}
 */
proto.profileservice.SearchBlog.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string user_icon_path = 11;
 * @return {string}
 */
proto.profileservice.SearchBlog.prototype.getUserIconPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setUserIconPath = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int32 price = 12;
 * @return {number}
 */
proto.profileservice.SearchBlog.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 favorite_count = 13;
 * @return {number}
 */
proto.profileservice.SearchBlog.prototype.getFavoriteCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setFavoriteCount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional bool is_favorited = 14;
 * @return {boolean}
 */
proto.profileservice.SearchBlog.prototype.getIsFavorited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setIsFavorited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool is_purchased = 15;
 * @return {boolean}
 */
proto.profileservice.SearchBlog.prototype.getIsPurchased = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.SearchBlog} returns this
 */
proto.profileservice.SearchBlog.prototype.setIsPurchased = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.BlogSitemapRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.BlogSitemapRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.BlogSitemapRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogSitemapRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userGroupId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    blogGroupId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.BlogSitemapRequest}
 */
proto.profileservice.BlogSitemapRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.BlogSitemapRequest;
  return proto.profileservice.BlogSitemapRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.BlogSitemapRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.BlogSitemapRequest}
 */
proto.profileservice.BlogSitemapRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserGroupId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.BlogSitemapRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.BlogSitemapRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.BlogSitemapRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogSitemapRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserGroupId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBlogGroupId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 user_group_id = 1;
 * @return {number}
 */
proto.profileservice.BlogSitemapRequest.prototype.getUserGroupId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogSitemapRequest} returns this
 */
proto.profileservice.BlogSitemapRequest.prototype.setUserGroupId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 blog_group_id = 2;
 * @return {number}
 */
proto.profileservice.BlogSitemapRequest.prototype.getBlogGroupId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogSitemapRequest} returns this
 */
proto.profileservice.BlogSitemapRequest.prototype.setBlogGroupId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.BlogSitemapReply.repeatedFields_ = [1,2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.BlogSitemapReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.BlogSitemapReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.BlogSitemapReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogSitemapReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    userGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    blogGroupIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    userIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    sitemapBlogsList: jspb.Message.toObjectList(msg.getSitemapBlogsList(),
    proto.profileservice.SitemapBlog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.BlogSitemapReply}
 */
proto.profileservice.BlogSitemapReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.BlogSitemapReply;
  return proto.profileservice.BlogSitemapReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.BlogSitemapReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.BlogSitemapReply}
 */
proto.profileservice.BlogSitemapReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setUserGroupIdsList(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlogGroupIdsList(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setUserIdsList(value);
      break;
    case 4:
      var value = new proto.profileservice.SitemapBlog;
      reader.readMessage(value,proto.profileservice.SitemapBlog.deserializeBinaryFromReader);
      msg.addSitemapBlogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.BlogSitemapReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.BlogSitemapReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.BlogSitemapReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogSitemapReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserGroupIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getBlogGroupIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
  f = message.getSitemapBlogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.profileservice.SitemapBlog.serializeBinaryToWriter
    );
  }
};


/**
 * repeated int32 user_group_ids = 1;
 * @return {!Array<number>}
 */
proto.profileservice.BlogSitemapReply.prototype.getUserGroupIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.setUserGroupIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.addUserGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.clearUserGroupIdsList = function() {
  return this.setUserGroupIdsList([]);
};


/**
 * repeated int32 blog_group_ids = 2;
 * @return {!Array<number>}
 */
proto.profileservice.BlogSitemapReply.prototype.getBlogGroupIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.setBlogGroupIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.addBlogGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.clearBlogGroupIdsList = function() {
  return this.setBlogGroupIdsList([]);
};


/**
 * repeated int32 user_ids = 3;
 * @return {!Array<number>}
 */
proto.profileservice.BlogSitemapReply.prototype.getUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * repeated SitemapBlog sitemap_blogs = 4;
 * @return {!Array<!proto.profileservice.SitemapBlog>}
 */
proto.profileservice.BlogSitemapReply.prototype.getSitemapBlogsList = function() {
  return /** @type{!Array<!proto.profileservice.SitemapBlog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.SitemapBlog, 4));
};


/**
 * @param {!Array<!proto.profileservice.SitemapBlog>} value
 * @return {!proto.profileservice.BlogSitemapReply} returns this
*/
proto.profileservice.BlogSitemapReply.prototype.setSitemapBlogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.profileservice.SitemapBlog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.SitemapBlog}
 */
proto.profileservice.BlogSitemapReply.prototype.addSitemapBlogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.profileservice.SitemapBlog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.BlogSitemapReply} returns this
 */
proto.profileservice.BlogSitemapReply.prototype.clearSitemapBlogsList = function() {
  return this.setSitemapBlogsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.SitemapBlog.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.SitemapBlog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.SitemapBlog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.SitemapBlog.toObject = function(includeInstance, msg) {
  var f, obj = {
    blogId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.SitemapBlog}
 */
proto.profileservice.SitemapBlog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.SitemapBlog;
  return proto.profileservice.SitemapBlog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.SitemapBlog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.SitemapBlog}
 */
proto.profileservice.SitemapBlog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.SitemapBlog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.SitemapBlog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.SitemapBlog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.SitemapBlog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlogId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int32 blog_id = 1;
 * @return {number}
 */
proto.profileservice.SitemapBlog.prototype.getBlogId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SitemapBlog} returns this
 */
proto.profileservice.SitemapBlog.prototype.setBlogId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.profileservice.SitemapBlog.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SitemapBlog} returns this
 */
proto.profileservice.SitemapBlog.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 updated_at = 3;
 * @return {number}
 */
proto.profileservice.SitemapBlog.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.SitemapBlog} returns this
 */
proto.profileservice.SitemapBlog.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetIsBloggerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetIsBloggerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetIsBloggerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetIsBloggerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetIsBloggerRequest}
 */
proto.profileservice.GetIsBloggerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetIsBloggerRequest;
  return proto.profileservice.GetIsBloggerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetIsBloggerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetIsBloggerRequest}
 */
proto.profileservice.GetIsBloggerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetIsBloggerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetIsBloggerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetIsBloggerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetIsBloggerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.profileservice.GetIsBloggerRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetIsBloggerRequest} returns this
 */
proto.profileservice.GetIsBloggerRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetIsBloggerReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetIsBloggerReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetIsBloggerReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetIsBloggerReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    isBlogger: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetIsBloggerReply}
 */
proto.profileservice.GetIsBloggerReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetIsBloggerReply;
  return proto.profileservice.GetIsBloggerReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetIsBloggerReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetIsBloggerReply}
 */
proto.profileservice.GetIsBloggerReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBlogger(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetIsBloggerReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetIsBloggerReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetIsBloggerReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetIsBloggerReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsBlogger();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_blogger = 1;
 * @return {boolean}
 */
proto.profileservice.GetIsBloggerReply.prototype.getIsBlogger = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.GetIsBloggerReply} returns this
 */
proto.profileservice.GetIsBloggerReply.prototype.setIsBlogger = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.Toc.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.Toc.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.Toc} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.Toc.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    anchor: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isPaid: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.Toc}
 */
proto.profileservice.Toc.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.Toc;
  return proto.profileservice.Toc.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.Toc} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.Toc}
 */
proto.profileservice.Toc.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnchor(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.Toc.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.Toc.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.Toc} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.Toc.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnchor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsPaid();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.profileservice.Toc.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.Toc} returns this
 */
proto.profileservice.Toc.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string anchor = 2;
 * @return {string}
 */
proto.profileservice.Toc.prototype.getAnchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.Toc} returns this
 */
proto.profileservice.Toc.prototype.setAnchor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_paid = 3;
 * @return {boolean}
 */
proto.profileservice.Toc.prototype.getIsPaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.Toc} returns this
 */
proto.profileservice.Toc.prototype.setIsPaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


goog.object.extend(exports, proto.profileservice);
